export const getCommentBlockId = (blockId: string) => `block-comments:${blockId}`;
